import React, { useState } from "react";
import DownArrow from "../icons/downArrow";
import UpArrow from "../icons/upArrow";
import styles from "./accordion.module.scss";
const AccordionItem = ({
    title,
    content,
}: {
    title: string;
    content: string;
}) => {
    const [opened, setOpen] = useState(false);
    return (
        <div
            className="bg-[#f8f8f8ad] flex flex-col rounded-[12px] py-5 px-4 gap-5"
            onClick={() => setOpen(!opened)}
        >
            <div
                className={`font-bold lg:text-xl text-sm leading-5 lg:leading-8 flex items-baseline justify-between cursor-pointer text-[#2d3e5e] `}
            >
                <div>{title}</div>
                <span>
                    {opened ? <UpArrow width={15} /> : <DownArrow width={15} />}
                </span>
            </div>
            <div
                className={`p-4 bg-white rounded-[10px] text-[#162b4e] lg:text-base text-sm ${
                    opened ? "h-auto" : "hidden"
                } ${styles.answer}`}
                dangerouslySetInnerHTML={{
                    __html: content,
                }}
            />
        </div>
    );
};

export default AccordionItem;
